/// <amd-module name="TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IOrganizationGroupsAwareState } from "TFS/Admin/Groups/Common/Contracts";
import { organizationGroupsReducer } from "TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsReducer";

import { groupsViewSaga } from "TFS/Admin/Groups/Common/Redux/GroupsViewSaga";
import { permissionsGroupsReducer } from "TFS/Admin/Groups/Pivots/Groups/Redux/GroupsPivotReducers";
import { permissionsGroupsSaga } from "TFS/Admin/Groups/Pivots/Groups/Redux/GroupsPivotSaga";
import { servicePrincipalsPivotReducer } from "TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotReducers";
import { servicePrincipalsPivotSaga } from "TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotSaga";
import { usersPivotReducer } from "TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotReducers";
import { usersPivotSaga } from "TFS/Admin/Groups/Pivots/Users/Redux/UsersPivotSaga";
import { membersPivotReducer } from "TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotReducers";
import { membersPivotSaga } from "TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotSaga";

export function getOrganizationGroupsModule(): ISagaModule<IOrganizationGroupsAwareState> {
    const reducerMap: ReducersMapObject<IOrganizationGroupsAwareState, AnyAction> = {
        pageState: organizationGroupsReducer,
        groupsState: permissionsGroupsReducer,
        usersState: usersPivotReducer,
        servicePrincipalsState: servicePrincipalsPivotReducer,
        membersState: membersPivotReducer,
    };

    return {
        id: "organizationGroupsState",
        reducerMap,
        sagas: [groupsViewSaga, permissionsGroupsSaga, usersPivotSaga, servicePrincipalsPivotSaga, membersPivotSaga]
    };
}
